<template>
  <div class="card" v-if="!isLoading">
    <argon-alert v-if="showAlert" color="danger">
      <strong>Alerta!</strong> Existen campos vacios que son obligatorios!
    </argon-alert>
    <argon-alert v-if="showSuccess" color="success" :dismissible="true">
      <strong>Completado!</strong> Campos guardados correctamente!
    </argon-alert>
    <div class="card-header pb-0">
      <div class="d-flex align-items-center">
        <h4 class="mb-0">Editar Información Principal</h4>
      </div>
    </div>
    <div class="card-body">
      <p class="text-uppercase text-sm">META</p>
      <div class="row">
        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label">Quiénes somos</label>
          <argon-textarea v-model="manageable.whoweare" @valid="absoluteValidation($event)" :isRequired="true" id="0"
            name="Quiénes somos" />
        </div>
        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label">Misión</label>
          <argon-textarea v-model="manageable.mission" @valid="absoluteValidation($event)" :isRequired="true" id="1"
            name="Misión" />
        </div>
        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label">Visión</label>
          <argon-textarea v-model="manageable.vision" @valid="absoluteValidation($event)" :isRequired="true" id="2"
            name="Visión" />
        </div>

        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label">Libramiento en San Luis Potosí</label>
          <argon-textarea v-model="manageable.bypassslp" @valid="absoluteValidation($event)" :isRequired="true" id="9"
            name="Libramiento_en_San_Luis_Potosí" />
        </div>

        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label">Nodo logístico</label>
          <argon-textarea v-model="manageable.node" @valid="absoluteValidation($event)" :isRequired="true" id="10"
            name="Nodo_logístico" />
        </div>

        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label">Visión responsable</label>
          <argon-textarea v-model="manageable.visionres" @valid="absoluteValidation($event)" :isRequired="true" id="11"
            name="Visión_responsable" />
        </div>

        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label">Sustentabilidad</label>
          <argon-textarea v-model="manageable.sustainability" @valid="absoluteValidation($event)" :isRequired="true"
            id="12" name="Sustentabilidad" />
        </div>

        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label"
            >Fundación nutriendo</label
          >
          <argon-textarea
            v-model="manageable.nurturing"
            @valid="absoluteValidation($event)"
            :isRequired="true"
            id="13"
            name="Fundación_nutriendo"
          />
        </div>
        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label"
            >Fundación nutriendo Link</label
          >
          <argon-input v-model="manageable.nurturinglink" id="14" name="fundacion" />
        </div>
        
        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label"
            >Empresa socialmente responsable</label
          >
          <argon-textarea
            v-model="manageable.businessres"
            @valid="absoluteValidation($event)"
            :isRequired="true"
            id="15"
            name="Empresa"
          />
        </div>

        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label"
            >Parador el Potosino</label
          >
          <argon-textarea
            v-model="manageable.hostel"
            @valid="absoluteValidation($event)"
            :isRequired="true"
            id="16"
            name="Parador"
          />
        </div>

        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label"
            >Infraestructura</label
          >
          <argon-textarea
            v-model="manageable.infrastructure"
            @valid="absoluteValidation($event)"
            :isRequired="true"
            id="17"
            name="Infraestructura"
          />
        </div>

        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label"
            >Auxilio vial</label
          >
          <argon-textarea
            v-model="manageable.helpvial"
            @valid="absoluteValidation($event)"
            :isRequired="true"
            id="18"
            name="Auxilio vial"
          />
        </div>

        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label"
            >Android</label
          >
          <argon-textarea
            v-model="manageable.androtext"
            @valid="absoluteValidation($event)"
            :isRequired="true"
            id="19"
            name="Android"
          />
        </div>
        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label"
            >Android Link</label
          >
          <argon-input v-model="manageable.androlink" id="20" name="Android Link" />
        </div>

        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label"
            >IOS</label
          >
          <argon-textarea
            v-model="manageable.iostext"
            @valid="absoluteValidation($event)"
            :isRequired="true"
            id="21"
            name="IOS"
          />
        </div> 

        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label"
            >IOS Link</label
          >
          <argon-input v-model="manageable.ioslink" id="22" name="IOS Link" />
        </div>

        

      </div>
      <hr class="horizontal dark" />
      <p class="text-uppercase text-sm">Contacto</p>
      <div class="row">
        <div class="col-md-6">
          <label for="example-text-input" class="form-control-label">Teléfono</label>
          <argon-input v-model="manageable.phone" @valid="absoluteValidation($event)" :isRequired="true" id="3"
            name="Teléfono" />
        </div>
        <div class="col-md-6">
          <label for="example-text-input" class="form-control-label">Correo</label>
          <argon-input type="email" v-model="manageable.email" @valid="absoluteValidation($event)" :isRequired="true"
            id="4" name="Correo" />
        </div>
        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label">Facturación</label>
          <argon-input v-model="manageable.billing" @valid="absoluteValidation($event)" :isRequired="true" id="5"
            name="Facturación" />
        </div>
      </div>
      <hr class="horizontal dark" />
      <p class="text-uppercase text-sm">Redes sociales</p>
      <div class="row">
        <div class="col-md-4">
          <label for="example-text-input" class="form-control-label">Facebook</label>
          <argon-input v-model="manageable.facebook" id="6" name="Facebook" />
        </div>
        <div class="col-md-4">
          <label for="example-text-input" class="form-control-label">Instagram</label>
          <argon-input v-model="manageable.instagram" id="7" name="Instagram" />
        </div>
        <div class="col-md-4">
          <label for="example-text-input" class="form-control-label">Twitter</label>
          <argon-input v-model="manageable.twitter" id="8" name="Twitter" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <argon-button color="primary" size="lg" class="ms-auto" @click-callback="finalValidation"
            :fullWidth="true">Guardar</argon-button>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "manageable-card",
  data() {
    return {
      isLoading: true,
      showAlert: false,
      showSuccess: false,
      valid: Array(23).fill(true),
      manageableID: undefined,
      manageable: {
        billing: "",
        email: "",
        facebook: "",
        instagram: "",
        phone: "",
        twitter: "",
        mission: "",
        vision: "",
        whoweare: "",
        bypassslp: "",
        node: "",
        visionres: "",
        nurturing: "",
        sustainability: "",
        nurturinglink: "",
        businessres: "",
        hostel: "",
        infrastructure: "",
        helpvial:"",
        androtext: "",
        androlink: "",
        iostext: "",
        ioslink:""
      },
    };
  },
  components: { ArgonInput, ArgonButton, ArgonTextarea, ArgonAlert },
  created() {
    this.plain
      .get(`/manageables`)
      .then((response) => {
        if (response.data.length !== 0) {
          this.manageableID = response.data[0].id;
          delete response.data[0].id;
          delete response.data[0].created_at;
          delete response.data[0].updated_at;
          this.manageable = response.data[0];
          this.isLoading = false;
          // console.log("RESPONSE");
          // console.log(this.manageable);
        }
        else
          this.isLoading = false;
      })
      .catch((err) => {
        this.isLoading = false;
        console.log(err);
      });
  },
  methods: {
    absoluteValidation(event) {
      this.showAlert = false;
      this.showSuccess = false;
      this.valid[event.inputIndex] = event.valid;
    },
    finalValidation() {
      if (this.valid.includes(false)) {
        this.showAlert = true;
        window.scrollTo(0, 0);
      } else {
        if (this.manageableID !== undefined) this.editManageable();
        else this.createManageable();
      }
    },
    createManageable() {
      this.plain
        .post("/manageables", this.manageable)
        .then((response) => {
          // console.log("ADMINISTRABLE creado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          this.manageableID = response.data.id;
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.manageable = response.data;
        })
        .catch((error) => {
          console.log("Error al crear ADMINISTRABLES", error);
        });
    },
    editManageable() {
      this.plain
        .patch(`/manageables/${this.manageableID}`, this.manageable)
        .then((response) => {
          // console.log("ADMINISTRABLE editado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          this.manageableID = response.data.id;
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.manageable = response.data;
          // console.log("EDIT");
          // console.log(this.manageable);
        })
        .catch((error) => {
          console.log("Error al editar ADMINISTRABLES", error);
        });
    },
  },
};
</script>